import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import EditPlayerOverlay from './EditPlayer';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faStar } from '@fortawesome/free-solid-svg-icons';
// import { faEdit } from '@fortawesome/free-solid-svg-icons';
import './DetailCard.css'; // Assuming you have a CSS file for styles

const DetailCard = ({ v, onSelectPlayer }) => {
  return (
    <div className="detail-card">
      <div className="player-data-row" onClick={() => onSelectPlayer(v)}>
        <span className="homejer">{v.homeJersey}</span>
        <span className="player-txt" title={v.playerName}>
          {v.playerName}
        </span>
        <button className="edit-button" onClick={(e) => {
          e.stopPropagation();
          onSelectPlayer(v);
        }}>
        </button>
        <span className="homejer">{v.awayJersey}</span>
      </div>
    </div>
  );
};

export default DetailCard;

